import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

import { PlayerPosition } from 'modules/teams/domain/enums/player-position';

/**
 * Состав команды: роль, номер и позиция участника.
 * Операции над самим игроком (фото) — в `modules/players/domain/resources/players-resource.ts`.
 */
class TeamParticipantsResource extends Resource {
  constructor() {
    super('teams', httpResource);
  }

  public async changeRole(teamId: number, userId: number, role: string, number: number | null, position: PlayerPosition | null) {
    return await this.absolute(`/teams/${teamId}/user-positions/${userId}`).put<any>({
      role: role.toLowerCase(),
      number,
      position,
    });
  }
}

const teamParticipantsResource = new TeamParticipantsResource();
export default teamParticipantsResource;
